import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Events } from "src/app/model/event";
import {
  DEFAULT_IMAGE,
  FTCHIMARRAO_IMAGE,
} from "src/app/model/mockup/image-mockup";
import { ListEvents } from "src/app/model/response/list-events-response";
import { AuthService } from "src/app/service/auth.service";
import { EventsService } from "src/app/service/events.service";

@Component({
  selector: "app-card-events",
  templateUrl: "./card-events.component.html",
  styleUrls: ["./card-events.component.css"],
})
export class CardEventsComponent implements OnInit {
  @Input() events!: ListEvents;
  @Output() checkInEvent = new EventEmitter<void>();
  @Output() infoEvent = new EventEmitter<void>();
  @Output() showQRCodeEvent = new EventEmitter<void>();

  userCheckedEvents: ListEvents[] = [];
  imageStyle: any;

  colorHex: string = "#b80e0eff";
  @Input() buttonsOpacity: string = "1";
  @Input() generalOpacity: string = "1";
  @Input() infoOpacity: string = "1";
  @Input() colorGenerated: string = "";
  @Input() hasCheckin: boolean = false;
  @Input() disableButtons: boolean = false;
  @Input() showQRCode: boolean = false;

  constructor(
    private eventService: EventsService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.setImageCard();
  }

  setImageCard() {
    let url = FTCHIMARRAO_IMAGE.href;
    this.imageStyle = "url(" + url + ")";
    return this.imageStyle;
  }


  checkIn(){
    this.checkInEvent.emit()
  }

  getInfoEvent() {
    this.infoEvent.emit()
  }

  onShowQRCode() {
    this.showQRCodeEvent.emit();
  }

}
